import React, { FC } from 'react';
import { Button, HStack, VStack } from '@chakra-ui/react';
import { Mode, useMintState } from '@app/state/mintStore';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import { useConfig } from '@app/config';
import { useLiquidityWizardState } from '@app/screens/liquidity/LiquidityWizard/state';

interface Props {}

export const ModeSelector: FC<Props> = () => {
  const config = useConfig();
  const {
    actions: { setMode, setProvider },
    mode,
    provider
  } = useLiquidityWizardState();

  if (!config?.FLAGS.showVaults) {
    return null;
  }

  function renderViewButton(label: string, _view: Mode) {
    const isActive = _view === mode;

    return (
      <Button
        variant="tertiary"
        onClick={() => {
          setMode(_view);

          if (_view === 'manual' && provider) {
            setProvider(null);
          }

          if (_view === 'auto' && !provider) {
            setProvider('steer');
          }
        }}
        sx={{
          fontSize: 14,
          color: isActive ? 'orange' : 'gray.4',
          bg: isActive ? 'gray.2' : 'transparent',
          textTransform: 'capitalize'
        }}
      >
        {label}
      </Button>
    );
  }

  return (
    <VStack w="100%" gap={4}>
      <AddLiquiditySectionTitle isCompleted label="Select a mode" />
      <HStack
        width="100%"
        sx={{
          borderRadius: '12px',
          border: '1px solid',
          borderColor: 'gray.5',
          padding: '6px'
        }}
      >
        {renderViewButton('Manual', 'manual')}
        {renderViewButton('Auto', 'auto')}
      </HStack>
    </VStack>
  );
};
